import type { Author } from '@bulknutrients/bulk-shared-lib/interfaces/Expert';
import { CustomImage } from '@components/Media/Image';
import { Paragraph } from '@components/Typography/Paragraph/Paragraph';
import { TextLink } from '@components/Typography/TextLink/TextLink';
import type { ReactElement } from 'react';

export function CategoryAuthor({ author }: { author: Author }): ReactElement {
  return (
    <aside className="mx-auto my-5 grid max-w-[480px] grid-cols-[100px_auto] items-center gap-3">
      {author.image && (
        <CustomImage
          image={{
            ...author.image,
            ...(author.profilePage && { internalLink: author.slug }),
          }}
          width={100}
          height={100}
          round
        />
      )}
      <Paragraph className="m-0">
        <strong>
          Reviewed by{' '}
          {author.profilePage ? (
            <TextLink href={author.slug}>{author.name}</TextLink>
          ) : (
            author.name
          )}
        </strong>
        <br />
        {author.singleLineDescription}
      </Paragraph>
    </aside>
  );
}
